import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap, Params, Router} from "@angular/router";
import {Category} from "../../../../Models/category";
import {CategoryService} from "../../../../Services/category.service";

@Component({
    selector: 'app-child-categories-filter',
    templateUrl: './child-categories-filter.component.html',
    styleUrls: ['./child-categories-filter.component.scss'],
    standalone: false
})
export class ChildCategoriesFilterComponent implements OnInit {

  selectedCategoryId?: number;
  selectedSubCategoryId?: number;
  selectedCategoryLabel?: String | null;
  categoryExpanded = false;
  categories?: Category[];
  selectedCateogries: number[] = [];
  RoutCategories: number[] | null = [];

  constructor(private router: Router, private route: ActivatedRoute,
              private categoryService: CategoryService,
  ) {
  }

  ngOnInit(): void {

    this.categoryService.categories.subscribe((categories: Category[]) => {
      this.categories = categories
    });

    this.route.params.subscribe((params: Params) => {
      this.selectedCategoryId = Number(params['id']);
      this.selectedSubCategoryId = Number(params['category']);

    });

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.selectedCategoryLabel = params.get('name')
    });

    this.route.queryParams.subscribe(params => {
      this.selectedCateogries = this.getActivatedRoute().snapshot.queryParamMap.getAll('categories').map(Number);

    });

  }

  get subCategories(): Category[] {
    return this.categories!.filter((category => category.parentId === this.selectedCategoryId && category.id === this.selectedSubCategoryId))
      .concat(this.categories!.filter(category => category.parentId === this.selectedCategoryId && category.id !== this.selectedSubCategoryId));
  }

  get subSubCategories(): Category[] {
    return this.categories!.filter(category => category.parentId === this.selectedSubCategoryId && this.selectedCateogries?.includes(category.id!))
      .concat(this.categories!.filter(category => category.parentId === this.selectedSubCategoryId && !this.selectedCateogries?.includes(category.id!)));
  }

  selectCategory(category: Category) {
    this.router.navigate(['/products/category',
      category.parentId,
      this.selectedCategoryLabel,
      category.id,
      category.label.replace(/[^a-zA-ZÀ-ÿ0-9]/g, '-'),
    ]);
  }

  selectCategory1(categoryId: number) {

    this.RoutCategories = this.getActivatedRoute()
      .snapshot.queryParamMap.getAll('categories')
      .map(Number);


    if (this.RoutCategories.includes(categoryId)) {
      this.RoutCategories = this.RoutCategories.filter((v) => v !== categoryId);
      //if no category niv 3 is selected put it to null
      if (this.RoutCategories.length == 0) this.RoutCategories = null;
    } else {
      this.RoutCategories = [...this.RoutCategories, categoryId];
    }

    this.router.navigate([], {
      relativeTo: this.getActivatedRoute(),
      queryParams: {categories: this.RoutCategories},
      queryParamsHandling: 'merge',
    });


  }

  getActivatedRoute(): ActivatedRoute {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  /**
   * check if level 2 of categories is checked
   */
  checked() {
    return this.subCategories.find(c => c.id === this.selectedSubCategoryId);
  }
}
